import styled from 'styled-components';

const CustomCheckboxGroupStyle = styled.div`
	--optionsContainerItemsGap: var(--sp4x);
	--optionContentItemsGap: var(--sp3x);
	--customCheckboxSize: var(--sp2-5x);
	--customCheckboxBorderRadius: var(--sp3x);
	--checkboxLabelDistance: var(--sp2x);
	--deltaCircle: 6px;

	display: flex;
	flex-direction: column;
	gap: var(--optionsContainerItemsGap);

	input[type='checkbox'] {
		display: none;
	}

	.custom-checkbox {
		display: block;
		min-width: var(--customCheckboxSize);
		height: var(--customCheckboxSize);
		border-radius: var(--customCheckboxBorderRadius);
		border: 1px solid var(--green1000);

		&.checked {
			position: relative;
			border-radius: var(--customCheckboxBorderRadius);
			background: transparent;

			&:after {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);

				content: '';
				display: block;
				min-width: calc(var(--customCheckboxSize) - var(--deltaCircle));
				height: calc(var(--customCheckboxSize) - var(--deltaCircle));
				border-radius: calc(var(--customCheckboxBorderRadius) / 2);
				background-color: var(--green1000);
			}
		}
	}

	.options-content {
		display: flex;
		flex-direction: column;
		gap: var(--optionContentItemsGap);
	}

	.options-wrapper {
		width: fit-content;
		display: flex;
		align-items: flex-start;
		gap: var(--checkboxLabelDistance);
		cursor: pointer;
	}

	.option-label {
		line-height: var(--customCheckboxSize);
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--optionsContainerItemsGap: var(--sp3x);
		--optionContentItemsGap: var(--sp2x);
		--customCheckboxSize: var(--sp2x);
		--customCheckboxBorderRadius: var(--sp3x);
		--checkboxLabelDistance: var(--sp1x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--optionsContainerItemsGap: var(--sp3x);
		--optionContentItemsGap: var(--sp2x);
		--customCheckboxSize: var(--sp2x);
		--customCheckboxBorderRadius: var(--sp3x);
		--checkboxLabelDistance: var(--sp1-5x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--optionsContainerItemsGap: var(--sp2-5x);
		--optionContentItemsGap: var(--sp2x);
		--customCheckboxSize: var(--sp2x);
		--customCheckboxBorderRadius: var(--sp3x);
		--checkboxLabelDistance: var(--sp1-5x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--optionsContainerItemsGap: var(--sp2-5x);
		--optionContentItemsGap: var(--sp2x);
		--customCheckboxSize: var(--sp2x);
		--customCheckboxBorderRadius: var(--sp3x);
		--checkboxLabelDistance: var(--sp1-5x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--optionsContainerItemsGap: var(--sp2-5x);
		--optionContentItemsGap: var(--sp1-5x);
		--customCheckboxSize: var(--sp2x);
		--customCheckboxBorderRadius: var(--sp3x);
		--checkboxLabelDistance: var(--sp1-5x);
		--deltaCircle: 4px;
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--optionsContainerItemsGap: var(--sp2-5x);
		--optionContentItemsGap: var(--sp1-5x);
		--customCheckboxSize: var(--sp2x);
		--customCheckboxBorderRadius: var(--sp3x);
		--checkboxLabelDistance: var(--sp1-5x);
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--optionsContainerItemsGap: var(--sp3x);
		--optionContentItemsGap: var(--sp2x);
		--customCheckboxSize: var(--sp2x);
		--customCheckboxBorderRadius: var(--sp3x);
		--checkboxLabelDistance: var(--sp1-5x);
	}
`;

export default CustomCheckboxGroupStyle;
